// extracted by mini-css-extract-plugin
export var infoItem = "_o6-2";
export var title = "_o6-0";
export var value = "_o6-1";